import { useState } from 'react';
import useFetchReducer from 'src/hooks/useFetchReducer';
import { FetchState } from 'src/reducers/fetchReducer';
import { ConvertedScriptConfiguration } from '../types/scriptConfiguration';
import {
  ScriptConfigurationParams,
  getScriptConfiguration,
  updateScriptConfiguration,
} from '../services/scriptConfiguration.service';
import { message } from 'antd';

export type ScriptConfigurationState = FetchState<ConvertedScriptConfiguration | null>;

const initialState: ScriptConfigurationState = {
  loading: false,
  error: false,
  data: null,
};
const useScriptConfiguration = (
  params: ScriptConfigurationParams
): [ScriptConfigurationState, (scriptDetails: ConvertedScriptConfiguration, onFinish: () => void) => void] => {
  const [{ data, error, loading }] = useFetchReducer(() => getScriptConfiguration(params), []);
  const [updateLoading, setUpdateLoading] = useState<boolean>(false);

  const saveScriptConfiguration = async (scriptConfiguration: ConvertedScriptConfiguration, onFinish: () => void) => {
    setUpdateLoading(true);
    try {
      const updatedScriptConfiguration = {
        ...scriptConfiguration,
        priorityOverride: scriptConfiguration.priorityOverride ?? 0,
        errorThresholdOverride: scriptConfiguration.errorThresholdOverride ?? 0,
    };
    const response = await updateScriptConfiguration(updatedScriptConfiguration);
    setUpdateLoading(false);
    message.success(response);
    onFinish();
    } catch (e) {
      console.error(e);
      message.error('An error occurred while updating script configuration.');
      setUpdateLoading(false);
    }
  };

  const state: ScriptConfigurationState = {
    ...initialState,
    loading: loading || updateLoading,
    error,
  };
  if (data) {
    return [{ ...state, data }, saveScriptConfiguration];
  } else {
    return [state, saveScriptConfiguration];
  }
};

export default useScriptConfiguration;
